/* eslint-disable no-restricted-syntax */
angular.module('tgaApp').controller('StartupController', [
  '$scope',
  '$rootScope',
  '$state',
  '$location',
  '$window',
  '$timeout',
  'gameService',
  'userService',
  'soundService',
  'analyticsService',
  'URLParamsService',
  '$translate',
  'gameConfig',
  'localStorageService',
  'IdleTimer',
  '$log',
  '$document',
  'TTAGameData',
  'messagingService',
  function (
    $scope,
    $rootScope,
    $state,
    $location,
    $window,
    $timeout,
    gameService,
    userService,
    soundService,
    analyticsService,
    URLParamsService,
    $translate,
    gameConfig,
    localStorageService,
    IdleTimer,
    $log,
    $document,
    TTAGameData,
    // need this to initialize the service
    // eslint-disable-next-line no-unused-vars
    messagingService,
  ) {
    $scope.game = {};
    $scope.slug = $state.params.slug || null;
    $scope.loading = true;
    $scope.alerts = [];
    $scope.URLParams = URLParamsService.getUserParams();
    $scope.analyticsService = analyticsService;
    gameConfig.music_muted = localStorageService.get('scenarios_game_music_muted') || false;
    gameConfig.sfx_muted = localStorageService.get('scenarios_game_sfx_muted') || false;

    // add new states here
    $scope.currentState = null;
    $scope.state = {
      splash: false,
      register: false,
      tutorial: false,
      game: false,
      gameover: false,
      unauthorized: false,
    };

    $rootScope.seenTutorial = false;

    $scope.reset = function () {
      $scope.gameData = {
        data: [],
        currentPoints: 0,
        currentScore: 0,
        repeat_question_history: null,
        question_transition: null,
        questionAnswered: false,
        questionIndex: -1,
        questionStartTime: 0,
        nextCardId: null,
        nextQuestionIndex: null,
        questions: [],
        originalQuestionSet: [],
        answers: [],
        sessionStartTime: Date.now(),
        currentStreak: 0,
        leaderboard: [],
        userAuthorized: null,
        questionsAnswered: 0,
        questionsAnsweredCorrect: 0,
        totalPausedTime: 0,
        showFeedback: false,
        showResults: false,
        showScore: false,
        showTutorial: false,
        answerHistory: [],
        previousAnswersArray: [],
        previousQuestionsArray: [],
        gameMaxPoints: 0,
        gameMinPoints: 0,
        pollCount: 0,
      };
    };

    $scope.initialize = function () {
      $log.debug('Startup state');
      $scope.reset();
      $scope.loading = true;

      return gameService
        .getGame({
          game_id: $rootScope.game_id,
          slug: $scope.slug,
          language_id: $scope.game.language_id,
          token: $rootScope.token,
        })
        .then((game) => {
          const parserResult = TTAGameData.Game.safeParse(game);
          if (!parserResult.success) {
            $log.info(parserResult.error);
            return;
          }
          $scope.game = parserResult.data;
          $scope.theme = $scope.game.assets.theme.indexOf('split') !== -1 ? 'split' : 'overlay';

          // Inject theme
          const linkElement = $document[0].createElement('link');
          linkElement.setAttribute('rel', 'stylesheet');
          linkElement.setAttribute('type', 'text/css');
          linkElement.setAttribute(
            'href',
            `build/css/${$scope.game.assets.theme}/${$scope.game.assets.theme}.css`,
          );
          $document[0].querySelector('head').appendChild(linkElement);

          if ($scope.URLParams.language) {
            const { language_id } = $scope.findLanguageByCode($scope.URLParams.language);
            if (language_id !== $scope.game.language_id) {
              $scope.game.language_id = language_id;
              $scope.URLParams.language = null;
              $scope.changeLanguage();
              return;
            }
          }

          const lang = $scope.findLanguageById(game.language_id);
          $translate.use(lang.code);
          angular.element('.gameContainer').addClass(lang.code);
          $scope.loading = false;

          $scope.loadMusic();

          if ($scope.game.authorization_type === 1 && !$scope.game.registration.required) {
            // if player list, but no registration or leaderboard check the player list auth right here
            userService
              .checkAuthorizedUser({
                slug: $scope.slug,
                email: $scope.URLParams.email,
                user_list_id: $scope.game.user_list_id,
              })
              .then((authorized) => {
                if (authorized) {
                  $scope.setState('splash');
                } else {
                  $scope.setState('unauthorized');
                }
              });
          } else if ($scope.game.authorization_type === 2) {
            // SSO
            if ($scope.game.sso_timeout > 0) {
              const ssoTimer = new IdleTimer();
              ssoTimer.options.inactive = $scope.game.sso_timeout;

              ssoTimer.on('inactive', () => {
                $window.location.href = `${$scope.game.sso_redirect_url}&logout=1`;
              });
            }
            if ($location.search().sessionToken) {
              userService.setUser(null);
              userService
                .login({
                  game_id: $scope.game.game_id,
                  token: $location.search().sessionToken,
                })
                .then(
                  () => {
                    $scope.setState('splash');
                    $location.search('sessionToken', null);
                  },
                  () => {
                    $window.location.href = $scope.game.sso_redirect_url;
                  },
                );
            } else {
              $window.location.href = $scope.game.sso_redirect_url;
            }
          } else {
            // if no authorization set, or there is a player list but also registration required
            $scope.setState('splash');
          }
        });
    };

    $scope.findLanguageById = function (id) {
      for (let i = 0; i < $scope.game.available_translations.length; i++) {
        const trans = $scope.game.available_translations[i];
        // untyped equality comparator is intentional
        // eslint-disable-next-line eqeqeq
        if (trans.language_id == id) {
          return trans;
        }
      }

      $log.debug('language ID could not be found in available translations, using english');

      return {
        language_id: 1,
        code: 'en_us',
        name: 'English (US)',
      };
    };

    $scope.findLanguageByCode = function (code) {
      for (let i = 0; i < $scope.game.available_translations.length; i++) {
        const trans = $scope.game.available_translations[i];
        // untyped equality comparator is intentional
        // eslint-disable-next-line eqeqeq
        if (trans.code == code) {
          return trans;
        }
      }

      $log.debug('language ID could not be found in available translations, using english');

      return {
        language_id: 1,
        code: 'en_us',
        name: 'English (US)',
      };
    };

    $scope.changeLanguage = function () {
      $scope.initialize();
    };

    $scope.loadMusic = function () {
      if ($scope.game.assets.track !== null && !soundService.isPlaying('music')) {
        soundService.load({
          src: $scope.game.assets.track,
          id: 'music',
          volume: gameConfig.musicVolume,
          loop: true,
          autoplay: !gameConfig.music_muted,
        });
      }
    };

    // change the state
    $scope.setState = function (stateName) {
      // set all to false
      Object.keys($scope.state).forEach((value) => {
        $scope.state[value] = false;
      });
      // set the passed in one to true
      $scope.state[stateName] = true;
      $scope.currentState = stateName;
    };
    $scope.alreadyRegistered = function () {
      return $rootScope.display_name !== null && angular.isDefined($rootScope.display_name);
    };
    $scope.getState = function () {
      for (const i in $scope.state) {
        if ($scope.state[i] === true) {
          return i;
        }
      }
      return undefined;
    };

    const pauseTimer = new IdleTimer();
    pauseTimer.options.inactive = 300; // 5 mins
    pauseTimer.options.disableOnInactive = false;
    pauseTimer.options.DOMevents.push('keydown');

    pauseTimer.on('inactive', () => {
      $scope.inactiveTimeStart = Date.now();
      pauseTimer.on('activity', () => {
        pauseTimer.off('activity');

        if ($scope.getState() === 'game') {
          $scope.gameData.totalPausedTime += Date.now() - $scope.inactiveTimeStart;
        }

        $scope.inactiveTimeStart = null;
      });
    });

    $scope.createAlert = function (message, alertType) {
      $scope.alerts.push({ msg: message, type: alertType });
    };

    $scope.initialize();
  },
]);
